<template>
    <div>

        <div class="form">
            <div class="titleStep" v-if="formData.product_type === 'fresh'">
                <h1>Cuéntanos sobre la alimentación de {{formData.petname}}</h1>
                <p>Esta información nos ayuda a personalizar su plan de comida fresca Le Fov.</p>
            </div>
            <div class="titleStep" v-else>
                <h1>¿Tiene {{formData.petname}} alergia a algo?</h1>
                <p>Nuestros snacks cumplen con los más altos estándares de nutrición. Pero siempre se pueden requerir condiciones especiales.</p>
            </div>
            <div class="wrap">
                <!-- Campos adicionales para Fresh -->
                <div v-if="formData.product_type === 'fresh'" class="columns is-multiline" style="margin-bottom: 2rem;">
                    <div class="column is-12">
                        <label class="label">Preferencia de proteína</label>
                        <b-field>
                            <b-select v-model="form.proteinPreference" placeholder="Selecciona una opción" expanded>
                                <option value="Sin preferencia">Sin preferencia</option>
                                <option value="Vacuno">Vacuno</option>
                                <option value="Pollo">Pollo</option>
                                <option value="Salmón">Salmón</option>
                                <option value="Pavo">Pavo</option>
                            </b-select>
                        </b-field>
                    </div>
                    
                    <div class="column is-12">
                        <label class="label">¿Qué comida consume actualmente?</label>
                        <b-field>
                            <b-input v-model="form.currentFood" placeholder="Ej: Royal Canin Adult, Proplan, etc."></b-input>
                        </b-field>
                    </div>
                    
                    <div class="column is-12">
                        <label class="label">Nivel de actividad</label>
                        <div class="activity-options">
                            <div class="activity-option">
                                <b-radio v-model="form.activityLevel"
                                    name="activity"
                                    native-value="Bajo"
                                    :class="[form.activityLevel === 'Bajo' ? 'active' : '']">
                                    <strong>Bajo</strong>
                                    <small>Paseos cortos, la mayor parte del día en casa</small>
                                </b-radio>
                            </div>
                            <div class="activity-option">
                                <b-radio v-model="form.activityLevel"
                                    name="activity"
                                    native-value="Medio"
                                    :class="[form.activityLevel === 'Medio' ? 'active' : '']">
                                    <strong>Medio</strong>
                                    <small>1-2 paseos diarios, juega regularmente</small>
                                </b-radio>
                            </div>
                            <div class="activity-option">
                                <b-radio v-model="form.activityLevel"
                                    name="activity"
                                    native-value="Alto"
                                    :class="[form.activityLevel === 'Alto' ? 'active' : '']">
                                    <strong>Alto</strong>
                                    <small>Ejercicio intenso diario, muy activo</small>
                                </b-radio>
                            </div>
                        </div>
                    </div>
                    
                    <div class="column is-12">
                        <hr style="margin: 1rem 0;">
                        <label class="label">Alergias o restricciones alimentarias</label>
                    </div>
                </div>
                
                <!-- Alergias (para todos los tipos) -->
                <div class="columns is-multiline">
                    <div class="column is-6">
                        <b-radio v-model="form.allergie"
                            name="name"
                            native-value="Pollo"
                            @input="hideAnotherInput"
                            :class="[form.allergie === 'Pollo' ? 'active' : '']"
                            >
                            Pollo
                        </b-radio>
                    </div>
                    <div class="column is-6">
                        <b-radio v-model="form.allergie"
                            name="name"
                            native-value="Pavo"
                            @input="hideAnotherInput"
                            :class="[form.allergie === 'Pavo' ? 'active' : '']"
                            >
                            Pavo
                        </b-radio>
                    </div>
                    <div class="column is-6">
                        <b-radio v-model="anotherOption"
                            name="name"
                            native-value="true"
                            @input="showAnotherInput"
                            :class="[anotherOption  ? 'active' : '']"
                            >
                            Otro
                        </b-radio>
                    </div>
                    <div class="column is-6">
                        <b-radio v-model="form.allergie"
                            name="name"
                            native-value="Nada"
                            @input="hideAnotherInput"
                            :class="[form.allergie === 'Nada' ? 'active' : '']"
                            >
                            Nada
                        </b-radio>
                    </div>
                    <div class="column is-12 v-column" v-if="$v.form.allergie.$error">
                        <p class="help is-danger">Alergia inválida</p>
                    </div>

                    <div class="column is-12" v-if="anotherOption">
                        <b-field>
                            <b-input v-model="form.allergie" placeholder="Alergia"></b-input>
                        </b-field>
                    </div>
                </div>
            </div>
            <b-button id="step-five-continue" type="is-primary nextButton" @click="nextStep" style="margin-top: 1.3rem">Continuar</b-button>
            <a class="backStep" @click="backStep">Volver</a>
            <div class="msg-sub">
                Si {{formData.petname}} tiene otras restricciones en su dieta, por favor ponte en contacto con nosotros antes de comprar para que podamos acomodar la mejor opción.
            </div>
        </div>
        
    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import StepMixin from '../../mixins/StepMixin'

    export default {
        props: ['clickedNext', 'currentStep'],
        mixins: [validationMixin, StepMixin],
        data() {
            return {
                form: {
                    allergie: '',
                    proteinPreference: 'Sin preferencia',
                    currentFood: '',
                    activityLevel: 'Medio',
                },
                anotherOption: false,
            }
        },
        computed: {
            formData(){
                return this.$parent.$parent.$parent.formData 
            }
        },
        validations: {
            form: {
                allergie: { required },
            }
        },
        methods : {
            hideAnotherInput(){
                this.anotherOption = false
            },
            showAnotherInput(){
                this.anotherOption = true
                this.form.allergie = null
            },
            nextStep(){
                this.$v.$touch()
                if (this.$v.$invalid) {
                    // Validación falló
                } else {
                    // Copiar sensibilidades digestivas desde alergias
                    this.form.digestiveSensitivities = this.form.allergie;
                    
                    console.log('🍖 [StepFive] Before merge - form data:', JSON.stringify(this.form, null, 2));
                    console.log('🍖 [StepFive] Before merge - parent formData:', JSON.stringify(this.parentComputed.formData, null, 2));
                    
                    // Forzar copia de todos los campos Fresh a formData
                    this.parentComputed.formData = {
                        ...this.parentComputed.formData,
                        ...this.form
                    };
                    
                    console.log('🍖 [StepFive] After merge - parent formData:', JSON.stringify(this.parentComputed.formData, null, 2));
                    
                    this.parentComputed.nextStep();
                }
            }
        },
        computed: {
            formData(){
                return this.$parent.$parent.$parent.formData 
            },
            parentComputed(){
                return this.$parent.$parent.$parent
            }
        }
    }
</script>

<style scoped>
.activity-options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.activity-option {
    padding: 1rem;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    transition: all 0.3s ease;
    height: auto !important;
    min-height: fit-content;
}

/* Height auto para radios de actividad */
.activity-option .b-radio.radio {
    height: auto !important;
    min-height: 40px;
}

.activity-option:hover {
    border-color: #3498db;
    background-color: #f8f9fa;
}

.activity-option.active {
    border-color: #3498db;
    background-color: #e3f2fd;
}

.activity-option strong {
    display: block;
    font-size: 1.1rem;
    margin-bottom: 0.25rem;
}

.activity-option small {
    display: block;
    color: #666;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .activity-option {
        padding: 0.75rem;
    }
    
    .activity-option strong {
        font-size: 1rem;
    }
    
    .activity-option small {
        font-size: 0.85rem;
    }
}
</style>